document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;

      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  initPredictiveSearch();
});

function initPredictiveSearch() {
  const roots = document.querySelectorAll('[data-predictive-search]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const input = root.querySelector('[data-predictive-search-input]');
    const results = root.querySelector('[data-predictive-search-results]');
    if (!input || !results) return;

    let timer;
    let controller;
    let lastQuery = '';

    const close = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      if (!results.innerHTML.trim()) return;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const fetchResults = async (query) => {
      const normalized = query.trim();
      if (normalized.length < 2) {
        close();
        return;
      }
      if (normalized === lastQuery && results.innerHTML.trim()) {
        open();
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const params = new URLSearchParams();
      params.set('q', normalized);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '6');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag,variants.sku,variants.barcode');
      params.set('section_id', 'predictive-search');

      root.classList.add('is-loading');
      try {
        const response = await fetch(`${rootUrl}search/suggest?${params.toString()}`, {
          signal: controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        const text = await response.text();
        if (!response.ok) throw new Error(`${response.status}: ${text}`);

        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const renderedSection = parsed.querySelector('#shopify-section-predictive-search');
        results.innerHTML = renderedSection ? renderedSection.innerHTML : '';
        lastQuery = normalized;
        open();
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn('Predictive search unavailable', error);
          close();
        }
      } finally {
        root.classList.remove('is-loading');
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => fetchResults(input.value), 180);
    });

    input.addEventListener('focus', () => {
      if (results.innerHTML.trim() && input.value.trim().length >= 2) open();
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        input.blur();
      }
      if (event.key === 'ArrowDown' && !results.hidden) {
        const firstLink = results.querySelector('a');
        if (firstLink) {
          event.preventDefault();
          firstLink.focus();
        }
      }
    });

    results.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        input.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) close();
    });
  });
}
